export default "__VITE_ASSET__C8R8Aqyk__"